import { csrfFetch } from "../utils/csrfFetch";
// Action Types
const LOAD_YARDS = "yards/LOAD_YARDS";
const UPDATE_YARD = "yards/UPDATE_YARD";
const DELETE_YARD = "yards/DELETE_YARD";
const CREATE_YARD = "yards/CREATE_YARD";
// Action Creators
export const loadYards = (yards) => ({
  type: LOAD_YARDS,
  payload: yards,
});

export const createYard = (yard) =>({
    type: CREATE_YARD,
    payload: yard,
})

export const editYard = (yard) => ({
  type: UPDATE_YARD,
  payload: yard,
});

export const deleteYard = (id) => ({
  type: DELETE_YARD,
  payload: id,
});


// Thunks
export const fetchYardsAdmin = () => async (dispatch) => {
  const response = await csrfFetch("/api/yards");
  if (response.ok) {
    const yards = await response.json();
    dispatch(loadYards(yards));
  }
};

export const fetchYardsUser = (accountId) => async (dispatch) => {
  try {
    let url = '/api/yards/';
    if (accountId) {
      url += `?account_id=${accountId}`;
    }

    const response = await csrfFetch(url);

    if (response.ok) {
      const yards = await response.json();
      dispatch(loadYards(yards));
      return yards;
    } else {
      const error = await response.json();
      throw new Error(error.error || 'Failed to fetch yards');
    }
  } catch (error) {
    console.error('Error fetching yards:', error);
    throw error;
  }
};


export const updateYard = (yardData) => async (dispatch) => {
  try {
    const response = await csrfFetch(`/api/yards/${yardData.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(yardData)
    });

    if (!response.ok) {
      const errors = await response.json();
      throw new Error(JSON.stringify(errors));
    }

    const yard = await response.json();
    dispatch(editYard(yard));
    return yard;
  } catch (error) {
    console.error('Error updating yard:', error);
    throw error;
  }
};

export const getYardById = (id) => async (dispatch) => {
  try {
    const response = await csrfFetch(`/api/yards/${id}`);
    if (!response.ok) {
      throw new Error('Failed to fetch yard');
    }
    const yard = await response.json();
    dispatch(editYard(yard));
    return yard;
  } catch (error) {
    console.error('Error fetching yard:', error);
    throw error;
  }
};

export const deleteYardAdmin = (id) => async (dispatch) => {
  try {
    const response = await csrfFetch(`/api/yards/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(JSON.stringify(errorData));
    }
    dispatch(deleteYard(id));
    return response;
  } catch (error) {
    console.error('Error deleting yard:', error);
    throw error;
  }
};

export const createYardAdmin = (yardData) => async (dispatch) => {
  try {
    const response = await csrfFetch('/api/yards/new', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...yardData,
        account_id: parseInt(yardData.account_id)
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw error;
    }

    const newYard = await response.json();
    dispatch(createYard(newYard));
    return newYard;
  } catch (error) {
    console.error('Error in createYardAdmin:', error);
    throw error;
  }
};

// Reducer
const initialState = [];

export default function yardsReducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_YARDS:
      return action.payload;
    case UPDATE_YARD:
      return state.map(yard =>
        yard.id === action.payload.id ? action.payload : yard
      );
    case DELETE_YARD:
      return state.filter(yard => yard.id !== action.payload);
    case CREATE_YARD:
      return [...state, action.payload];
    default:
      return state;
  }
}
